<template>

  <div>

    <v-navigation-drawer
      app
      v-model="drawer"
      temporary
    >
    <v-list>
      <v-subheader>Jurnal Categories</v-subheader>
      <template v-if="categoryLoader">
          <v-sheet
          >
            <v-skeleton-loader
              v-for="i in 12"
              :key="'skeleton-category-'+i"
              class="mx-auto"
              type="list-item"

            ></v-skeleton-loader>
          </v-sheet>
      </template>
      <template v-else >

          <v-list-item
            v-for="item in categories"
            :key="item.id"
            link
            @click.native="filterCategory(item.id)"
          >
            <v-list-item-content>
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon small :color="(item.id === categoryCurrent ? 'primary' : 'grey')">mdi-circle</v-icon>
            </v-list-item-action>
          </v-list-item>
      </template>
      </v-list>

    </v-navigation-drawer>

    <v-app-bar app color="secondary darken-1" dark elevation="0" elevate-on-scroll>
      <v-btn icon text>
        <v-btn icon text @click.native="openCategory()">
          <v-icon>mdi-filter</v-icon>
        </v-btn>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title class="title">{{ categoryName || 'All Category' }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon text>
        <v-btn icon text @click.native="infoDialog = true">
          <v-icon>mdi-information-outline</v-icon>
        </v-btn>
      </v-btn>
    </v-app-bar>

      <v-container fluid class="pa-0 ma-0">

        <!-- seach -->
            <v-text-field
              v-model="keyword" :placeholder="'Search...'"
              full-width
              clearable
              solo
              hide-details
              color="primary"
              prepend-inner-icon="mdi-magnify"
              class="ma-4"
            />

        <template v-if="loading">

          <v-sheet
          >
            <v-skeleton-loader
              v-for="i in 6"
              :key="'loader-'+i"
              class="mx-auto"
              type="list-item-two-line"

            ></v-skeleton-loader>
          </v-sheet>
        </template>

        <template v-else>

          <v-alert class="ma-4" type="error" v-if="error">Gagal memuat data...</v-alert>

          <v-list three-line flat>
            <template v-for="(item,i) in items">

                  <v-list-item
                    :key="'item-'+i"
                    link
                    :to="'/jurnal/show/'+item.id"
                  >
                      <v-list-item-content>
                          <v-list-item-subtitle class="mb-1"><v-chip x-small label outlined color="primary" class="overline" v-text="item.category"></v-chip></v-list-item-subtitle>
                          <v-list-item-title v-text="item.title"></v-list-item-title>
                          <v-list-item-subtitle v-text="item.author"></v-list-item-subtitle>
                      </v-list-item-content>

                      <v-list-item-action>
                        <v-btn icon>
                            <v-icon color="grey lighten-1">mdi-chevron-right</v-icon>
                        </v-btn>
                      </v-list-item-action>
                  </v-list-item>
                  <v-divider :key="'item'+i"></v-divider>

            </template>
          </v-list>

        </template>

        <v-dialog  v-model="infoDialog">
          <v-sheet>
          <v-card flat tile>
            <v-card-text class="text-center pa-8">
              <h4 class="subtitle">Version 1.0</h4>
              <p class="body-2 pa-0 ma-0">Jurnal Ekonomi</p>
            </v-card-text>
          </v-card>
          <v-divider></v-divider>
          <About />
          </v-sheet>
        </v-dialog>

      </v-container>
  </div>
</template>

<script>
import About from '@/components/About'
export default {
  name: 'Jurnal',
  inject: ['theme'],
  components: {
    About
  },
  watch: {
    categoryCurrent: function (val) {
      this.fetchData()
    },
    keyword: function (val) {
      this.categoryCurrent = 0
      this.fetchData()
    }
  },

  data: () => ({
    error: null,
    loading: false,
    keyword: '',
    results: [],

    selected: null,
    sheetModel: false,

    drawer: null,
    categoryCurrent: 2, // category id
    categories: [],
    categoryLoader: false,
    infoDialog: false

  }),
  created () {
    this.categoryCurrent = 0
  },
  methods: {
    openCategory () {
      if (this.categories.length == 0) {
        this.fetchCategory()
      }

      this.drawer = true
    },
    encodeQueryData: (data) => {
      const ret = []
      for (let d in data) { ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d])) }
      return ret.join('&')
    },

    fetchData () {
      this.error = null
      this.loading = true
      var url = 'journal'

      /* query string */
      let queryString = {}
      if (this.categoryCurrent != 0) {
        queryString.category = this.categoryName
      }
      if (this.keyword != '') {
        queryString.keyword = this.keyword
      }
      url += '?' + this.encodeQueryData(queryString)
      /* end query string */

      this.$axios
        .get(url)
        .then(response => { this.results = response.data.results })
        .catch(error => this.error = error)
        .finally(() => this.loading = false)
    },
    async fetchCategory () {
      this.categoryLoader = true
      const url = 'journal/category'
      const response = await this.$axios
        .get(url)
      this.categories = response.data.results
      this.categoryLoader = false
    },
    filterCategory (categoryid) {
      this.categoryCurrent = categoryid
      this.drawer = false
    }

  },
  computed: {

    categoryName: function () {
      if (this.categories.length == 0) return

      return this.categories.filter(each => {
        return each.id == this.categoryCurrent
      })[0].name
    },
    items () {
      return this.results
    }
  }
}
</script>
